import { Button, Card, Flex, Layout, Space, Typography } from "antd";
import { Bookmark, Check, FileDown, Redo, X } from "lucide-react";
import { useExamStore } from "@store";
import { chooseQuestionTypeLayout } from "./helpers";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import parse from 'html-react-parser';
import { getBaseFrontendUrl } from "../../context/helpers";

export const ExamContent = () => {
  const currentQuestion = useExamStore((state) => state.clickedQuestion);

  const {t} = useTranslation();
  
  return (
    <Layout>
      <Card
        title={`1. ${t("pages.bankPool.question")}`}
        className="custom-card"
        style={{ marginBottom: 30 }}
      >
        <Flex justify="space-between" wrap="wrap">
          <Button type="primary" shape="round" ghost icon={<Bookmark />}>
            {t("pages.bankPool.think")}
          </Button>
          <Space style={{ display: "flex", alignItems: "center" }}>
            <Typography.Text>{t("pages.bankPool.points")}:</Typography.Text>
            <Check style={{ color: "green" }} />
            <Typography.Text>{currentQuestion?.correctAnswerPoints}</Typography.Text>
            <X style={{ color: "red" }} />
            <Typography.Text>
              {currentQuestion?.incorrectAnswerPoints}
            </Typography.Text>
            <Redo />
            <Typography.Text>{currentQuestion?.unansweredPoints}</Typography.Text>
          </Space>
        </Flex>
        <div key={`${currentQuestion?.id}-${currentQuestion?.text}`}>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 1 }}
        >
          <Space
            direction="vertical"
            
          >
            <Typography.Title level={5}>{t("pages.bankPool.question")}:</Typography.Title>
            <Typography.Text>{parse(currentQuestion!.text)}</Typography.Text>
            {currentQuestion?.attachments?.map((attachment) => (
              <Typography.Link
                key={attachment.id}
                download={attachment.name}
                href={`${getBaseFrontendUrl()}${attachment.path}`}
                target="_blank"
              >
                <FileDown /> {attachment.name}
              </Typography.Link>
            ))}

          </Space>
        </motion.div>
        </div>
        
      </Card>
      {chooseQuestionTypeLayout()}

    </Layout>
  );
};
